import { getDefaultFontFamily } from './get-default-font-family';

export function setDefaultFontFamily(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--fontFamily', getDefaultFontFamily());
}
